import PaginationState from '../pagination/PaginationState'
import App from '../App'

export default class ListTasksMutationPayload {
  pagination: PaginationState<App>

  constructor (pagination: PaginationState<App>) {
    this.pagination = pagination
  }
}
